window.connectionAssistanceAppConfig = {
    industry: {
        automotive: {
            id: 1,
            show: false
        },
        marine: {
            id: 2,
            show: true
        },
        onHighway: {
            id: 3,
            show: false
        },
        offHighway: {
            id: 4,
            show: false
        },
        motorcycle: {
            id: 5,
            show: true
        }
    }
}